module.exports = __webpack_public_path__ + "img/youxiu.560ede7b.png";